import { useState } from 'react'
import { ShoppingCartIcon, StarIcon } from '@heroicons/react/24/outline'
import SEO from '../components/SEO'
import { trackPurchaseClick, trackPreviewDownload, trackCoverFlip, trackEvent } from '../utils/analytics'

export default function Book() {
  const [showBack, setShowBack] = useState(false)
  const bookStructuredData = {
    "@context": "https://schema.org",
    "@type": "Book",
    "name": "Indoctri-NATION 365",
    "author": {
      "@type": "Person",
      "name": "Kim Synergy"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Buckingham Publishing"
    },
    "copyrightHolder": {
      "@type": "Organization",
      "name": "Synergy Unlimited LLC"
    },
    "description": "A Practical Guide for White People Ready to Help Dismantle Systemic Racism",
    "isbn": "0996043691",
    "image": "https://indoctrination365.com/actual-bookcover.png",
    "url": "https://indoctrination365.com/book",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "price": "0",
      "priceCurrency": "USD",
      "url": "https://www.amazon.com/dp/0996043691",
      "seller": {
        "@type": "Organization",
        "name": "Amazon"
      }
    },
    "genre": ["Non-fiction", "Social Justice", "Education"],
    "about": [
      "Systemic Racism",
      "Racial Equity",
      "Social Justice",
      "American History"
    ]
  }

  return (
    <main className="py-16">
      <SEO 
        title="Get the Book"
        description="Buy Indoctri-NATION 365 - A practical guide for white people ready to help dismantle systemic racism. Available on Amazon and signed copies direct from the author."
        keywords="Indoctri-NATION 365, systemic racism book, anti-racism guide, racial justice, Kim Synergy, white privilege, social justice book, diversity and inclusion"
        url="https://indoctrination365.com/book"
        type="book"
        structuredData={bookStructuredData}
      />
      <div id="top" />
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold mb-6">Indoctri-NATION 365</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A Practical Guide for "White" People Ready to Help Dismantle Systemic Racism
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start mb-16">
          <div className="text-center">
            <div className="w-full max-w-lg mx-auto rounded-lg overflow-hidden mb-4 cursor-pointer hover:scale-[1.02] transition-transform" style={{boxShadow: '0 15px 35px rgba(0,0,0,0.25)'}} onClick={() => setShowBack(!showBack)}>
              <img 
                src={showBack ? "/back-cover.png" : "/actual-bookcover.png"}
                alt={showBack ? "Indoctri-NATION 365 back cover" : "Indoctri-NATION 365 front cover"}
                className="w-full h-auto object-contain transition-opacity duration-300"
              />
            </div>
            <button
              onClick={() => { setShowBack(!showBack); trackCoverFlip(showBack ? 'front' : 'back') }}
              className="text-primary-600 font-semibold text-lg hover:text-primary-700 transition-colors mb-4"
            >
              {showBack ? '← View front cover' : 'View back cover →'}
            </button>
          </div>

          <div className="space-y-6">
            <div>
              <h2 className="text-2xl font-semibold mb-4">What You'll Learn</h2>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary-600 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></span>
                  <span>The real history you were never taught in school</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary-600 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></span>
                  <span>How systemic racism operates in everyday life</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary-600 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></span>
                  <span>Practical tools for difficult conversations</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary-600 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></span>
                  <span>Action steps for meaningful change</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary-600 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></span>
                  <span>How to move from awareness to accountability</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold mb-3">Book Excerpt</h3>
              <blockquote className="text-gray-700 italic">
                "If you've never questioned these stories before, that's not your fault. 
                But if you've made it this far and you're still reading, you no longer 
                get to hide behind the myth. The version of America we were taught to 
                love was never the full story. And love that's based on lies isn't love 
                at all. It's control."
              </blockquote>
            </div>

            {/* Free Preview Download */}
            <a
              href="/PublicSample_INDOCTRINATION_365.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackPreviewDownload()}
              className="block w-full text-center border-2 border-primary-600 text-primary-600 px-4 py-3 rounded-lg font-semibold hover:bg-primary-50 transition-colors"
            >
              📖 Download Free Preview
            </a>
            <p className="text-sm text-gray-500 text-center -mt-4">Includes Table of Contents, Preface, Chapter 1, and About the Author</p>

            <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-start">
              <div className="flex flex-col items-center gap-1 flex-1">
                <a
                  href="https://buy.stripe.com/cNi00i31m971bS3bch6sw02"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackPurchaseClick('signed_copy')}
                  className="w-full bg-primary-600 text-white px-4 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 hover:bg-primary-700 transition-colors whitespace-nowrap"
                  aria-label="Buy signed copy directly from the author"
                >
                  <ShoppingCartIcon className="w-5 h-5" aria-hidden="true" />
                  Signed Copy - Discounted
                </a>
                <span className="text-sm text-gray-700 font-semibold">US shipping only - by author</span>
              </div>
              <div className="flex flex-col items-center gap-1 flex-1">
                <a
                  href="https://www.amazon.com/dp/0996043691"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackPurchaseClick('amazon')}
                  className="w-full bg-primary-600 text-white px-4 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 hover:bg-primary-700 transition-colors"
                  aria-label="Buy on Amazon"
                >
                  <ShoppingCartIcon className="w-5 h-5" aria-hidden="true" />
                  Buy on Amazon
                </a>
                <span className="text-sm text-gray-700 font-semibold">Available in paperback & Kindle</span>
              </div>
            </div>

            <div className="mt-6 text-center bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <div className="flex justify-center items-center gap-1 mb-2">
                {[...Array(5)].map((_, i) => (
                  <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" aria-hidden="true" />
                ))}
                <span className="ml-2 text-gray-600">5-star rated on Amazon</span>
              </div>
              <p className="text-gray-700 mb-2 font-medium">If you like it so far…</p>
              <a
                href="https://www.amazon.com/review/create-review/?ie=UTF8&channel=glance-detail&asin=0996043691"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('review_click', { platform: 'amazon' })}
                className="inline-block bg-yellow-500 text-white px-6 py-3 rounded-lg font-semibold text-lg hover:bg-yellow-600 transition-colors"
              >
                ⭐ Leave a Review on Amazon
              </a>
            </div>
          </div>
        </div>

        <div className="bg-primary-50 rounded-lg p-8">
          <h2 className="text-2xl font-semibold mb-6 text-center">Perfect For</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <h3 className="text-lg font-semibold mb-3">Individual Readers</h3>
              <p className="text-gray-700">
                Anyone ready to understand systemic racism and take meaningful action
              </p>
            </div>
            <div className="text-center">
              <h3 className="text-lg font-semibold mb-3">Book Clubs</h3>
              <p className="text-gray-700">
                Discussion questions and reflection prompts included for group learning
              </p>
            </div>
            <div className="text-center">
              <h3 className="text-lg font-semibold mb-3">Educators</h3>
              <p className="text-gray-700">
                Classroom resources and teaching materials available
              </p>
            </div>
          </div>
        </div>
      </div>

    </main>
  )
}